/**
 * Swahili for MUI's own strings and the date pickers, neither of which ships one. Same shape
 * as `esES` from "@mui/material/locale" and "@mui/x-date-pickers/locales", so it merges into
 * the theme the same way. The pickers' field placeholders (DD/MM/YYYY) stay as they are:
 * Swahili's siku/mwezi/mwaka would make day, month and year all start with S or M.
 */

const pageAriaLabel = (type) => {
  if (type === "first") return "Nenda ukurasa wa kwanza";
  if (type === "last") return "Nenda ukurasa wa mwisho";
  if (type === "next") return "Nenda ukurasa unaofuata";
  return "Nenda ukurasa uliotangulia";
};

export const swMaterial = {
  components: {
    MuiBreadcrumbs: { defaultProps: { expandText: "Onyesha njia" } },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: pageAriaLabel,
        labelRowsPerPage: "Safu kwa kila ukurasa:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}–${to} kati ya ${count !== -1 ? count : `zaidi ya ${to}`}`,
      },
    },
    MuiRating: {
      defaultProps: {
        getLabelText: (value) => `Nyota ${value}`,
        emptyLabelText: "Hakuna",
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        clearText: "Futa",
        closeText: "Funga",
        loadingText: "Inapakia…",
        noOptionsText: "Hakuna chaguo",
        openText: "Fungua",
      },
    },
    MuiAlert: { defaultProps: { closeText: "Funga" } },
    MuiPagination: {
      defaultProps: {
        "aria-label": "Kurasa",
        getItemAriaLabel: (type, page, selected) =>
          type === "page" ? `${selected ? "" : "Nenda "}ukurasa ${page}` : pageAriaLabel(type),
      },
    },
  },
};

const VIEWS = { year: "mwaka", month: "mwezi", day: "siku", hours: "saa", minutes: "dakika", seconds: "sekunde" };
const viewName = (view) => VIEWS[view] || view;

export const swPickers = {
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: {
          previousMonth: "Mwezi uliopita",
          nextMonth: "Mwezi ujao",
          openPreviousView: "fungua mwonekano uliotangulia",
          openNextView: "fungua mwonekano unaofuata",
          calendarViewSwitchingButtonAriaLabel: (view) =>
            view === "year"
              ? "mwonekano wa miaka uko wazi, badilisha kwenda kalenda"
              : "kalenda iko wazi, badilisha kwenda mwonekano wa miaka",
          start: "Mwanzo",
          end: "Mwisho",
          cancelButtonLabel: "Ghairi",
          clearButtonLabel: "Futa",
          okButtonLabel: "Sawa",
          todayButtonLabel: "Leo",
          datePickerToolbarTitle: "Chagua tarehe",
          dateTimePickerToolbarTitle: "Chagua tarehe na saa",
          timePickerToolbarTitle: "Chagua saa",
          dateRangePickerToolbarTitle: "Chagua kipindi cha tarehe",
          clockLabelText: (view, time, adapter) =>
            `Chagua ${viewName(view)}. ${
              time === null ? "Hakuna saa iliyochaguliwa" : `Saa iliyochaguliwa ni ${adapter.format(time, "fullTime")}`
            }`,
          hoursClockNumberText: (hours) => `saa ${hours}`,
          minutesClockNumberText: (minutes) => `dakika ${minutes}`,
          secondsClockNumberText: (seconds) => `sekunde ${seconds}`,
          selectViewText: (view) => `Chagua ${viewName(view)}`,
          calendarWeekNumberHeaderLabel: "Namba ya wiki",
          calendarWeekNumberHeaderText: "#",
          calendarWeekNumberAriaLabelText: (weekNumber) => `Wiki ${weekNumber}`,
          calendarWeekNumberText: (weekNumber) => `${weekNumber}`,
          openDatePickerDialogue: (value, utils) =>
            value !== null && utils.isValid(value)
              ? `Chagua tarehe, tarehe iliyochaguliwa ni ${utils.format(value, "fullDate")}`
              : "Chagua tarehe",
          openTimePickerDialogue: (value, utils) =>
            value !== null && utils.isValid(value)
              ? `Chagua saa, saa iliyochaguliwa ni ${utils.format(value, "fullTime")}`
              : "Chagua saa",
          fieldClearLabel: "Futa thamani",
          timeTableLabel: "chagua saa",
          dateTableLabel: "chagua tarehe",
        },
      },
    },
  },
};
